<template>
  <el-dialog
    :title="title"
    :visible.sync="pool_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="addressWrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item prop="operator" label="专利池运营方">
          <el-input v-model="form.operator" placeholder="请填写专利池运营方" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="poolName" label="专利池名称">
          <el-input v-model="form.poolName" placeholder="请填写专利池名称" maxlength="50"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align:center;" class="mt30">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { poolSave, poolUpdate, poolView } from "@/api/index";
export default {
  props: {
    pool_dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "新增",
      form: {
        operator:'',
        poolName:'',
      },
      rules: {
        poolName: [
          { required: true, message: "请输入专利池名称", trigger: "blur" }
        ],
        operator: [{ required: true, message: "请输入专利池运营方", trigger: "blur" }]
      },
    };
  },
  mounted() {
    if (this.id) {
      this.title = "修改";
      poolView(this.id).then(res => {
        this.form = {
          ...res.data,
          awardYear: String(res.data.awardYear)
        };
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:pool_dialogVisible", false);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            //修改
            poolUpdate({
              ...this.form,
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.$emit("update:pool_dialogVisible");
                this.$emit("refresh");
              }
            });
          } else {
            //新增
            poolSave({
              ...this.form,
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.$emit("update:pool_dialogVisible");
                this.$emit("refresh");
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>